import React, { FC, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import PortalSelectionStore from "./store";
import ClientManagementStore from "../Admin/ClientManagement/store";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Card, CardBody, CardHeader, CardText } from "reactstrap";
import {
  getSecondarySessionKey,
  getSessionKey,
  purgeSecondarySessionKey,
  purgeSecondaryUser,
} from "../../utils/SsoSession";
import env from "../../config/env";
import { ClientDto } from "../Admin/ClientManagement/types";
import { MessageResultState } from "../../types/general-types";

const { DOMAIN_URL } = env;

interface IPage {
  PortalSelectionStore?: PortalSelectionStore;
}

const PortalSelectionPage: FC<IPage> = inject("PortalSelectionStore")(
  observer((props: IPage) => {
    const { i18n, t } = useTranslation();
    const sessionKey = getSecondarySessionKey()
      ? getSecondarySessionKey()
      : getSessionKey();
    const queryParams = new URLSearchParams(window.location.search);
    const returnUrl = queryParams.get("returnUrl");
    const [clients, setClients] = useState<ClientDto[]>([]);
    const [expanded, setExpanded] = useState<{ [key: number]: boolean }>({});

    useEffect(() => {
      new ClientManagementStore()?.getUserClients().then((res) => {
        if (res.state === MessageResultState.SUCCESS) {
          setClients(res.result);
        }
      });
    }, []);

    const handleExpandToggle = (index: number, event: React.MouseEvent) => {
      event.stopPropagation();
      setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const descriptionThreshold = 150;

    return (
      <div className="container mt-3" style={{ height: "100%" }}>
        <div className="row">
          <div className="row mb-2 text-center">
            <h4>
              <span>{t("Please select the portal you want to login.")}</span>
            </h4>
          </div>

          {_.map(clients, (client, i) => {
            const isExpanded = expanded[i];

            const description =
              i18n.language === "en" && client.description_EN
                ? client.description_EN
                : client.description;
            const name =
              i18n.language === "en" && client.name_EN
                ? client.name_EN
                : client.name;
            return (
              <div className="col-12 col-md-4 mt-2 py-3" key={i}>
                <Card
                  className="my-2 m-2 grow"
                  inverse
                  onClick={() => {
                    if (client.redirectUri && client.redirectUri.trim()) {
                      window.location.href =
                        client.redirectUri +
                        (returnUrl ? "?returnUrl=" + returnUrl : "") +
                        (returnUrl ? "&" : "?sessionKey=" + sessionKey);
                      purgeSecondarySessionKey();
                      purgeSecondaryUser();
                    }
                  }}
                  style={{
                    background: "linear-gradient(45deg, #A31D1D, #D84040)",
                    height: "100%",
                    cursor: "pointer",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <CardHeader
                    style={{
                      fontWeight: "bold",
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    <strong>{name}</strong>
                  </CardHeader>

                  <CardBody
                    style={{
                      color: "#ebd9d9",
                      padding: "1rem",
                    }}
                  >
                    <CardText style={{ textAlign: "left" }}>
                      <label
                        style={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: !isExpanded ? 3 : "unset",
                        }}
                      >
                        {description}
                      </label>
                      {description.length > descriptionThreshold && (
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            color: "#e4e4e4",
                            cursor: "pointer",
                          }}
                          onClick={(e) => handleExpandToggle(i, e)}
                        >
                          {isExpanded ? t("Show Less") : t("Read More")}
                        </button>
                      )}
                    </CardText>
                  </CardBody>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    );
  })
);

export default PortalSelectionPage;
